var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('MainLayout',[_c('iframe',{attrs:{"src":"https://p.us5.datadoghq.com/sb/embed/d876666c-ae77-11ef-98a7-6ecd5e8e56fb-afb6791c8c84000efde999d5200e4088","title":"Dashboard Name","width":"100%","height":"800"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }